import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/Index/swiperArrow.png'


const _withScopeId = n => (_pushScopeId("data-v-71e16941"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "min-wrap flex-center bg-teacher",
  style: {"overflow":"hidden"}
}
const _hoisted_2 = { class: "wrap-container pt50" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "index_classify" }, [
  /*#__PURE__*/_createElementVNode("span", null, "专家团队")
], -1))
const _hoisted_4 = { class: "index_swiper" }
const _hoisted_5 = { class: "box" }
const _hoisted_6 = { class: "teacher-card" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "teacher-info flex-col flex-center" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sep-line-v" }, null, -1))
const _hoisted_11 = { class: "job" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "swiper-button-next"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "swiper-button-prev"
}, null, -1))

import {reactive, ref} from "vue";
import SwiperCore, {Navigation, Autoplay,Pagination} from "swiper";
import {Swiper, SwiperSlide} from 'swiper/vue'
import "swiper/scss";
import "swiper/scss/navigation";
// 新增分页样式导入
import "swiper/scss/pagination";
interface ITeacher {
  name: string;
  title: string;
  description: string;
  imgName:string
}

// 轮播图配置

export default /*#__PURE__*/_defineComponent({
  __name: 'Teacher',
  setup(__props) {

SwiperCore.use([Navigation, Autoplay,Pagination]);
const swiper_options: any = reactive({
  slides_per_view: 4,
  space_between: 10,
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: true
  // },
  autoplay:false,
  loop: false,
  navigation: {
    nextEl: '.swiper-button-next', //前进后退按钮
    prevEl: '.swiper-button-prev',
  },
  pagination: {  // 新增分页配置
    el: '.swiper-pagination',
    clickable: true,
  },
});
const list = ref<ITeacher[]>([
  {
    imgName: '1',
    name: '宋承敏',
    title: '国家发改委教授研究员',
    description: '国家宏观经济管理<br/>编辑部副主任'
  },
  {
    imgName: '2',
    name: '王小广',
    title: '经济学博士',
    description: '中共中央党校（国家行政学院）<br/>经济学部副主任'
  },
  {
    imgName: '3',
    name: '王喜文',
    title: '博士后、高级工程师',
    description: '京华夏工联网智能技术研究院院长 <br/>工业4.0研究所所长'
  },
  {
    imgName: '4',
    name: '傅思明',
    title: '教授、博士生导师',
    description: '中央党校政法教研部宪法<br/> 与行政法教研室主任'
  },
  {
    imgName: '5',
    name: '李良栋',
    title: '中央党校政法教研部教授',
    description: '研究社会主义民主政治、 <br/>西方政治思潮、政治文化理论'
  },
  {
    imgName: '6',
    name: '牛广瀑',
    title: '工程技术应用研究员',
    description: '山东省有突出贡献的中青年专家<br/>山东省科技进步先进工作者'
  },
  {
    imgName: '7',
    name: '宋柏允',
    title: '宏观经济解读专家',
    description: '东方华尔金融教育高级研究员<br/>华尔街通科技金融战略分析师'
  },
  {
    imgName: '8',
    name: '马兆林',
    title: '互联网顶层智慧研究院院长',
    description: '北京大学、清华大学<br/>等知名高校特约讲师'
  },
  {
    imgName: '9',
    name: '周新军',
    title: '管理学博士、经济学博士后',
    description: '南开大学企业管理专业博士<br/>中国社会科学院应用经济学博士后'
  },
  {
    imgName: '10',
    name: '李军',
    title: '北京工商大学硕士生导师',
    description: '原住建部建设部部长<br/>高级经济师、副研究员'
  },
  {
    imgName: '11',
    name: '纪柚安',
    title: '副教授、硕士生导师',
    description: '任教于河北科技大学<br/>化学工程与技术专业硕士学位'
  },
  {
    imgName: '12',
    name: '李俊',
    title: '副教授',
    description: '安徽理工大学教授<br/>经济学博士'
  },
  {
    imgName: '13',
    name: '李喜琴',
    title: '国家卫健委党校研究员',
    description: '主要研究医院党建<br/>医院廉政建设等'
  },
  {
    imgName: '14',
    name: '王政',
    title: '清华大学思想文化史硕士',
    description: '北京大学学士<br/>美国访问学者'
  },
  {
    imgName: '15',
    name: '苏英',
    title: '北京大学医学部心理学系讲师',
    description: '中国心理学会注册心理师<br/>精神分析学派学者'
  },
  {
    imgName: '16',
    name: '陈霞',
    title: '博士、学科化学专家',
    description: '北京师范大学博士、副教授，拥有<br/>专业及教材教法研究十七年'
  },
  {
    imgName: '17',
    name: '靳澎',
    title: '国家二级心理咨询师',
    description: '从事心理咨询、教师培训<br/>等工作十余年'
  },
  {
    imgName: '18',
    name: '朱涛',
    title: '教授、建筑师',
    description: '美国哥伦比亚大学建筑硕士<br/>建筑历史理论专业博士'
  },
  {
    imgName: '19',
    name: '王子健',
    title: '一级建造师、建筑经济师',
    description: '多年参与一级、二级建造师<br/>培训与编写等方面的工作'
  },
  {
    imgName: '20',
    name: '廖光哲',
    title: '一级建造师、中级经济师',
    description: '毕业于南京航空航天大学<br/>硕士研究生学历'
  }
])
const getImg = (name: string) => {
  // console.log('图片最终路径：', new URL(`@/assets/images/teacher/${name}.png`, import.meta.url).href); // 检查路径是否正确
  // console.log('图片最终路径1111：', new URL(`@/assets/images/teacher/1.png`, import.meta.url).href); // 检查路径是否正确
  // return new URL(`@/assets/images/teacher/${name}.png`, import.meta.url).href
  return require(`@/assets/images/teacher/${name}.png`);
}

const onresize = () => {
  swiper_options.slides_per_view = 5
}

window.onresize = onresize
onresize()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Swiper), {
          "space-between": swiper_options.space_between,
          navigation: swiper_options.navigation,
          autoplay: swiper_options.autoplay,
          loop: swiper_options.loop,
          pagination: swiper_options.pagination
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil(list.value.length/5), (i) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: i }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value.slice((i-1)*5, i*5), (item) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("img", {
                          src: getImg(item.imgName)
                        }, null, 8, _hoisted_7),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("h1", null, _toDisplayString(item.name), 1),
                          _createElementVNode("p", {
                            innerHTML: item.description
                          }, null, 8, _hoisted_9),
                          _hoisted_10,
                          _createElementVNode("div", _hoisted_11, _toDisplayString(item.title), 1)
                        ])
                      ]))
                    }), 256))
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _hoisted_12,
            _hoisted_13,
            _hoisted_14
          ]),
          _: 1
        }, 8, ["space-between", "navigation", "autoplay", "loop", "pagination"])
      ])
    ])
  ]))
}
}

})